import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    mode: 'light',
}

const themeSlice = createSlice({
    name: 'theme',
    initialState,
    reducers: {
        setTheme: (state, action) => {
            state.mode = action.payload
        },
    },
})

export const themeActions = themeSlice.actions

export default themeSlice.reducer

